// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
//= require messages/_namespace
//= require_tree ./templates
//= require_tree ./views
//= require_tree ./behaviors
//= require_tree .
// MAGIC_DESPROCKET_START
require('sprocket-compat?this!javascripts/messages/_namespace.coffee')
require('javascripts/messages/templates/form_JST.wjs.js')
require('sprocket-compat?this!javascripts/messages/views/form_view.js')
require('sprocket-compat?this!javascripts/messages/views/modal_form_view.coffee')
require('sprocket-compat?this!javascripts/messages/behaviors/message_button.coffee')
require('sprocket-compat?this!javascripts/messages/recipient_finder.coffee')
// MAGIC_DESPROCKET_END
